<script lang="ts">
    import { Button, Col } from "sveltestrap";
    import { AlertState, Danger, Information, Success, Warning } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import swal from 'sweetalert';
    const handleAlert =(id)=>{
        if(id === 1){
            swal({
                title: "Good job!",
                text: "You clicked the button!",
                icon: "success",
            });
        }
        else if(id === 2){
            swal({
                title: "Good job!",
                text: "You clicked the button!",
                icon: "error",
            });
        }
        else if(id === 3){
            swal({
                title: "Good job!",
                text: "You clicked the button!",
                icon: "info",
            });
        }
        else if(id === 4){
            swal({
                title: "Good job!",
                text: "You clicked the button!",
                icon: "warning",
            });
        }
    }
</script>
<Col sm="12">
    <Card headerTitle={AlertState} cardBodyprops="btn-showcase" cardHeaderprops="pb-0">
        <div slot="contentbody">
            <Button color="success" id=1 on:click={()=>handleAlert(1)} class="sweet-8" >{Success}</Button>
            <Button color="danger" id=2 on:click={()=>handleAlert(2)} class="sweet-7" >{Danger}</Button>
            <Button color="info" id=3 on:click={()=>handleAlert(3)} class="sweet-9" >{Information}</Button>
            <Button color="warning" id=4 on:click={()=>handleAlert(4)} class="sweet-6" >{Warning}</Button>
        </div>
    </Card>
</Col>